module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_5000_10000.c8d94e49.png";